<template>
    <div class="register">
        <div v-if="!showForget && !loginSuc && !elseLoginWay && !qrLoginWay"
            :class="schoolShowFlag ? 'login_popup login_popup_c' : 'login_popup'">
            <div v-if="nextPage == 1" class="login_index">
                <!-- 默认登录页 -->
                <div class="mess_pop">
                    <div v-if="ifNotied" class="notied fadein" v-text="ifNotiedText"></div>
                </div>
                <div class="register_container">
                    <div class="register_title">
                        注册账号
                    </div>
                    <div class="register_message">
                        <!-- <div v-if="showErrCode" class="code_inp"> -->
                        <div v-if="showImgErrCode && tabActive == 0" class="code_inp">
                            <!-- <div v-if="true" class="code_inp"> -->
                            <dragView @offbtn="offDarg" />
                            <!-- 三次密码错误 -->
                            <img id="codePic" src alt title="点击刷新" @click="getCodeErr()" />
                            <span class="code_btn" title="获取验证码" @click="getCodeErr()">获取验证码</span>
                            <input name="code" type="text" maxlength="50" id="errverCode" placeholder="请输入验证码"
                                autocomplete="new-password" v-model.trim="errverCode" />
                            <div v-if="showError" class="err_mess">
                                <p id="errMessP" v-text="errPop"></p>
                            </div>
                        </div>
                        <div class="login_input">
                            <div class="user_inp">
                                <input v-if="tabActive == 2" type="text" name="tel1" style="
                      position: absolute;
                      font-size: 0;
                      width: 1px;
                      height: 1px;
                      padding: 0;
                      border-bottom: 0 !important;
                    " />
                                <el-input :type="inputType" maxlength="50" class="telNumber" v-model.trim="telNumber"
                                    :class="{ 'error_input': errPop1 }" placeholder="请输入手机号" @focus="userFocus"
                                    @blur="userBlur" />
                            </div>
                            <div v-if="errPop1" class="err_mess">
                                    <p id="errMessP" v-text="errPop1"></p>
                                </div>
                            <div class="pass_inp">
                                <el-input v-if="tabActive == 2" type="text" name="x_code1" style="
                                          position: absolute;
                                           font-size: 0;
                                          width: 1px;
                                          height: 1px;
                                          padding: 0;
                                           border-bottom: 0 !important;" />
                                <p class="getCode cursor_p" :id="getCodeAfter ? 'getcodeAfter' : null" @click="getCode()"
                                    v-text="getCodeAfter ? '已发送(' + codeAfterNum + 's)' : '获取验证码'">
                                </p>
                                <!-- 验证码输入框 -->
                                <el-input name="x_code" type="text" maxlength="50" id="verCode" placeholder="请输入验证码"
                                    :class="{ 'error_input': errPop2 }" v-model.trim="verCode"
                                    />
                                <div v-if="errPop2" class="err_mess">
                                    <p id="errMessP" v-text="errPop2"></p>
                                </div>
                            </div>
                            <div class="code_inp" v-if="showErrCode">
                                <!-- 三次密码错误 -->
                                <img id="codePic" :src="codeImgSrc" alt title="点击刷新" @click="getCaptcha()" />
                                <!-- <span class="code_btn" title="获取验证码"  @click="getCodeErr()">获取验证码</span> -->
                                <input name="x_code" type="text" maxlength="4" id="errverCode" placeholder="请输入验证码"
                                    autocomplete="new-password" v-model.trim="errverCode"
                                    />
                            </div>
                        </div>
                        <div class="login_btn">
                            <button class="cursor_p" @click="subMit()">注册</button>
                        </div>
                        <div v-if="tabActive == 0" class="operation_account">
                            <div class="register_box">
                                <span class="guide_language">已有账号？</span>
                                <span class="register_button" @click="$emit('backspace')">去登录</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 其他登陆方式  -->
                <div class="else_login">
                    <div class="else_box">
                        <div class="app_func">
                            <p class="fif_notice_bottom">
                                注册即代表同意
                                <a class="privacy_policy" target="_blank" onmouseover="this.style.cursor='hand'"
                                    href="https://www.fifedu.com/interface/html/H5-Agreement.html">《讯飞高教隐私权政策》</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /*  忘记密码框 */ -->
        <forgetView v-else-if="showForget && !loginSuc" @offForget="changeShowForget($event)"></forgetView>
        <!-- /* 学工号登陆 */ -->
        <elseView v-if="elseLoginWay" @offSchoolList="changeElse($event)"></elseView>
        <el-dialog title="修改密码" :visible.sync="dialogVisible" :close-on-click-modal="false" width="30%">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                <p style="margin-top: 0">
                    为保障您的数据安全，请按照密码规则修改弱密码
                </p>
                <el-form-item label="用户名">
                    <el-input v-model="userName" readonly></el-input>
                </el-form-item>
                <el-form-item label="原始密码" prop="pwd">
                    <el-input type="password" v-model="ruleForm.pwd"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="pwdNew">
                    <el-input type="password" v-model="ruleForm.pwdNew"
                        placeholder="长度需8-20位，数字、小写字母、大写字母、特殊字符，至少包含三种"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" prop="pwdNew1">
                    <el-input type="password" v-model="ruleForm.pwdNew1"
                        placeholder="长度需8-20位，数字、小写字母、大写字母、特殊字符，至少包含三种"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="changePwd">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import axios from "axios";
import CryptoJS from "crypto-js";
import $ from "jquery";
import { EduSSO } from "../../static/utils/sso.js";
/* 组件引入 */
import forgetView from "../components/forgetView.vue";
import elseView from "../components/elseView.vue";
import dragView from "../components/logindDrag";
import RegisterAnAccount from "../components/RegisterAnAccount.vue";

import {
    checkUserName,
    verifiCation,
    getRegisterCode,
    checkValidateCode,
    registerAnAccount,
    updatePwdNew,
} from "../request/api-ysx";

// const stream = weex.requireModule('stream');
export default {
    name: 'home',
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入新密码"));
            } else {
                if (value !== "") {
                    if (
                        !/((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,20}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,20}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,20}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,20}$))/.test(
                            value
                        )
                    )
                        callback(
                            new Error(
                                "长度需8-20位，数字、小写字母、大写字母、特殊字符，至少包含三种"
                            )
                        );
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入新密码"));
            } else if (value !== this.ruleForm.pwdNew) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            inputType: 'text',
            showTeacherBackground: '',
            codeImgSrc: "",
            loginTab: ["账号登录", "1", "手机登录"],
            tabActive: 0, // 登陆方式切换+控制指定功能显示隐藏
            userName: "", // v-m 账号
            passWord: "", // v-m 密码
            telNumber: "", // v-m 手机号
            errverCode: "", // 输错三次密码
            showErrCode: false, // 显示对应验证码框
            showImgErrCode: false, // 显示对应拖拽图片验证码框
            codeImg: "", // 验证码图片
            verCode: "", // v-m 验证码
            uuid: "", // v-m 验证码 暂存
            showError: false, // 验证码错误
            passType: "password",
            passShowHide: false,

            showErr: false, // 错误信息显示
            errPop1: "", // 错误信息1
            errPop2: "", // 错误信息2
            nextPage: 1, // 账号——身份绑定页面
            tiedSuc: false, // 身份手机号绑定成功
            idTiednumSuc: false, // 绑定后登陆成功

            showNotied: false, // 手机——显示未绑定提示信息
            showForget: false, // 显示忘记密码页面
            getCodeAfter: false, // 显示验证码倒计时
            codeAfterNum: 60, // 验证码数字倒计时
            ifNotied: false, // 判断是否绑定-弹框
            ifNotiedText: "",
            // codeSucced: false, // 账号验证码成功

            // QrUrl: '',      // 微信/钉钉二维码登录地址
            QrType: "", // 微信/钉钉二维码标识

            elseLoginWay: false, // 学工号登陆

            qrLoginWay: false, // 二维码登录

            loginSuc: false, // 登陆成功页面
            sucTo: 1, // 跳转成功 倒计时
            isOnline: false, // 是否为线上
            schoolShowFlag: false,
            //强制修改密码
            dialogVisible: false,
            ruleForm: {
                pwd: "",
                pwdNew: "",
                pwdNew1: "",
            },
            rules: {
                pwd: [{ required: true, message: "请输入原始密码", trigger: "blur" }],
                pwdNew: [{ required: true, validator: validatePass, trigger: "blur" }],
                pwdNew1: [
                    { required: true, validator: validatePass2, trigger: "blur" },
                ],
            },
            backUrl: '',//需要返回的地址
        };
    },
    components: {
        forgetView,
        elseView,
        dragView,
        RegisterAnAccount
    },
    created() {
        // 绑定回车事件
        var _this = this;
        document.onkeydown = function (e) {
            let key = window.event.keyCode;
            if (key == 13) {
                _this.subMit();
            }
        };
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == "schoolCode") {
                this.schoolShowFlag = true;
            }
        }
    },
    methods: {
        changePwd() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    var Base64 = require("js-base64").Base64;
                    const key = CryptoJS.enc.Utf8.parse("dufy20170329java"); //16位
                    const iv = CryptoJS.enc.Utf8.parse("dufy20170329java");
                    const srcs1 = CryptoJS.enc.Utf8.parse(this.ruleForm.pwd);
                    let encrypted1 = CryptoJS.AES.encrypt(srcs1, key, {
                        iv: iv,
                        mode: CryptoJS.mode.CBC,
                        padding: CryptoJS.pad.Pkcs7,
                    });
                    const srcs2 = CryptoJS.enc.Utf8.parse(this.ruleForm.pwdNew);
                    let encrypted2 = CryptoJS.AES.encrypt(srcs2, key, {
                        iv: iv,
                        mode: CryptoJS.mode.CBC,
                        padding: CryptoJS.pad.Pkcs7,
                    });
                    let params = {
                        loginName: this.userName,
                        pwd: Base64.encode(encrypted1),
                        newPwd: Base64.encode(encrypted2),
                    };
                    updatePwdNew({ ...params }).then((res) => {
                        if (res.status != "SUCCESS")
                            return this.$message.error(res.message);
                        this.$message({ message: res.message, type: "success" });
                        this.dialogVisible = false;
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        getCaptcha() {
            $.ajax({
                url:
                    `${window.globalParameter.VUE_APP_CYCORE}/fif_captcha` +
                    "/getCaptcha?t_=" +
                    Date.parse(new Date()),
                success: (data) => {
                    this.codeImgSrc = JSON.parse(data).data.image;
                    this.uuid = JSON.parse(data).data.uuid;
                },
            });
        },
        //获取主机url
        getHostPath() {
            var curWwwPath = window.document.location.href;
            var pathName = window.document.location.pathname;
            var pos = curWwwPath.indexOf(pathName);
            var localhostPath = curWwwPath.substring(0, pos);
            this.isOnline = localhostPath.indexOf("hecs.fifedu.com/iplat/");
            return localhostPath;
        },
        //获取iplat路径
        getIplatPath() {
            var curWwwPath = window.document.location.href;
            var pos = curWwwPath.indexOf("/fifLogin");
            var iplatPath = curWwwPath.substring(0, pos);
            return iplatPath;
        },
        //获取iplat路径 线上下
        getIplatCasPath() {
            // 线上
            var login = `${window.globalParameter.VUE_APP_CYCORE}/cas-server`;
            return login;
        },
        tabLogin(ind) {
            this.tabActive = ind;
            this.telNumber = "";
            this.userName = "";
            this.passWord = "";
            this.errverCode = "";
            this.showErr = false;
            this.errPop1 = ''
            this.errPop2 = ''
            this.inputType = 'password'
        },
        hidePass() {
            if (this.passType == "password") {
                this.passType = "text";
                this.passShowHide = true;
            } else {
                this.passType = "password";
                this.passShowHide = false;
            }
        },
        forgetPass() {
            // 打开忘记密码框
            this.showForget = true;
        },
        changeShowForget(data) {
            // 关闭 忘记密码
            this.showForget = data;
        },
        changeElse(data) {
            this.elseLoginWay = data;
        },
        /* 获取验证码 */
        getCode() {
            console.log("<<<<<<<<<<<<<<<<<<<<<<");
            // this.showErr = false;
            const that = this;
            var canToget = false;
            if (this.telNumber == "") {
                this.errPop1 = "请输入手机号";
                this.showErr = true;
                canToget = true;
                return false;
            } else if (!/^1\d{10}$/i.test(this.telNumber)) {
                this.errPop1 = "请输入正确的手机号";
                canToget = true;
                return false;
            } else {
                canToget = true;
            }
            if (this.codeAfterNum == 60) {
                this.showImgErrCode = true;
            }
        },
        getCodeFunc(tokenId,x,y) {
            //获取验证码-图形拖拽后调用发送验证码
            getRegisterCode({ mobile: this.telNumber,uuid:tokenId,X:x,Y:y })
                .then((res) => {
                    if (res.status == 1) {
                        // that.codeSucced = true;
                        this.getCodeAfter = true;
                        this.showImgErrCode = false;
                        var serCodeAfter = setInterval(() => {
                            this.codeAfterNum -= 1;
                            if (this.codeAfterNum == 0) {
                                clearInterval(serCodeAfter);
                                this.getCodeAfter = false;
                                this.codeAfterNum = 60;
                            }
                        }, 1000);
                    } else {
                        if (res.status == 0) {
                            this.ifNotied = true;
                            this.ifNotiedText = res.message;
                            this.showImgErrCode = false;
                            var setTifNo = setTimeout(() => {
                                this.ifNotied = false;
                                clearTimeout(setTifNo);
                            }, 3000);
                        }
                    }
                })
                .catch((err) => {
                    this.ifNotied = true;
                    this.ifNotiedText =
                        "该手机号未绑定账号，请使用账号登录后在设置中绑定手机号";
                    var setTifNo = setTimeout(() => {
                        this.ifNotied = false;
                        clearTimeout(setTifNo);
                    }, 3000);
                    console.log(err);
                });
        },
        /* 账号密码 focus blur 事件 */
        userFocus() {
            this.inputType = 'text'
        },
        userBlur() {
            if (
                !/^1\d{10}$/i.test(this.telNumber) &&
                this.telNumber != ""
            ) {
                this.showErr = true;
                this.errPop1 = "请输入正确的手机号";
                return false;
            } else {
                this.showErr = false;
                this.errPop1 = "";
            }
        },
        /* 账号密码 focus blur 事件 */
        // 点击注册
        subMit() {
            const that = this;
            var Tuser = "";
            var Tpass = "";
            var Tcode = "";
            if (this.telNumber == "") {
                this.errPop1 = "请输入手机号";
                this.showErr = true;
                // $(".telNumber").css({ "border-bottom": "#3388FF solid 1px" });
                return false;
            } else if (this.verCode == "") {
                this.errPop2 = "请输入验证码";
                this.showErr = true;
                // $("#verCode").css({ "border-bottom": "#3388FF solid 1px" });
                return false;
            } else if (this.telNumber != "" && this.verCode != "") {
                this.registerAccount()
            } else if (this.telNumber == "") {
                $(".user_inp input").focus();
            } else if (this.verCode == "") {
                $(".pass_inp input").focus();
            }

        },

        // 进行账号注册
        async registerAccount() {
            const params = {
                mobile: this.telNumber,
                code: this.verCode,
                url: this.backUrl
            }
            const res = await registerAnAccount(params)
            if (res.status == 1) {
                this.$message.success('注册成功')
                this.backUrl ? sessionStorage.setItem('backUrl', this.backUrl) : sessionStorage.removeItem('backUrl')
                // this.$emit('backspace', res.data) // 前往登录
                this.goToLogin(res.data)
            } else {
                if (res.message == '验证码错误') return this.errPop2 = res.message;
                this.$message.error(res.message)
            }
        },

        //获取iplat路径
        getIplatPath() {
            var curWwwPath = window.document.location.href;
            var pos = curWwwPath.indexOf("/fifLogin");
            var iplatPath = curWwwPath.substring(0, pos);
            return iplatPath;
        },

        // 进行登录
        goToLogin(data) {
            const Tcode = ''
            const Tuser = data.username;
            const Tpass = data.password;
            // 登录
            var loginurl = this.getIplatPath() + "/ssoservice";
            var edusso = new EduSSO(loginurl, this.getIplatCasPath());
            // 先退出登录
            edusso.casLogout(function (result) { });
            edusso.login(
                "iflyportal",
                "iflyportal",
                "login_name",
                Tuser,
                Tpass,
                Tcode,
                (result) => {
                    // 成功跳转
                    var loginSucTo = setInterval(() => {
                        clearInterval(loginSucTo);
                        window.location.href =
                            this.getIplatPath() + "/ssoservice";
                    }, 1000);
                }
            );
        },

        // 关闭验证码弹窗
        offDarg(v,x,y) {
            if (v == false) {
                this.showImgErrCode = v;
            } else if (this.tabActive == 0) {
                this.getCodeFunc(v,x,y);
            } else {
                this.uuid = v;
                this.checkPass();
            }
        },
    },
    mounted() {
        let url = location.href
        if (url.indexOf('shortName=zyzlxs') != -1) { this.showTeacherBackground = 1 }
        if (url.indexOf('shortName=zyzljs') != -1) { this.showTeacherBackground = 2 }
        if (url.indexOf('showWay=1') != -1) {
            const params = url.split('returnAddress=')[1]
            this.backUrl = unescape(params).split('&showWay=')[0]
            console.log(this.backUrl);
        }
    },
};
</script>
<style scoped lang="scss">
@import url("../style/login");

input::-ms-clear {
    display: none;
}

input::-ms-reveal {
    display: none;
}

.err_mess {
    position: relative;
    min-height: 14px;
    width: 240px;
}

.err_mess p {
    font-size: 12px;
    line-height: 14px;
    color: #ff553a;
    letter-spacing: 0;
}

.code_inp {
    position: relative;
}

#codePic {
    position: absolute;
    top: 0px;
    right: 0;
    /* margin-top: 5px;
    margin-left: 30px; */
    width: 100px;
    height: 40px;
    background-color: #f4f4f4;
}

.code_btn {
    position: absolute;
    top: 12px;
    right: 25px;
    font-size: 12px;
    color: #3388ff;
    cursor: pointer;
}

.el-form-item {
    margin-bottom: 12px;
}

.el-input .el-input__inner::placeholder {
    color: #C2C7CC !important;
}

.register_container {
    padding-top: 60px;

    .register_title {
        font-size: 24px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #12151a;
        line-height: 28px;
    }
}

.register_message {
    padding: 48px 32px 0 32px;
}

.login_btn {
    margin-top: 24px;
}

.fif_notice_bottom {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    letter-spacing: 0;
    text-align: center;
    width: 100%;
    margin: 0;

    .privacy_policy {
        color: #3D444D;
        text-decoration: none;
    }
}
</style>
  


// WEBPACK FOOTER //
// src/components/RegisterAnAccount.vue